'use strict';

angular.module('contentful')
/**
 * Small helper controller to make the `cfWidgetRenderer` directive work.
 *
 * Used in the `entity_sidebar.mixin.jade` template.
 */
.controller('SidebarWidgetRenderController', ['$scope', 'require', ($scope, require) => {
  var TheLocaleStore = require('TheLocaleStore');
  var $controller = require('$controller');

  $scope.field = $scope.widget.field;
  $scope.locale = TheLocaleStore.getDefaultLocale();
  $scope.fieldLocale = $controller('FieldLocaleController', {
    $scope: $scope,
    // TODO We should remove this dependency from the
    // FieldLocaleController.
    $attrs: {}
  });
}]);



// WEBPACK FOOTER //
// ./src/javascripts/app/entity_editor/sidebar_widgets_controller.js